import React, { useState, useEffect } from 'react'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../common/snippets'
import { Box } from '@mui/system'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useSelector } from 'react-redux'
import { colors } from '../../../common/helper'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { detailedColumnsMemoStyles, excelHeader, jsPdfHeaderFooter, StationWiseMemoCol, StationWiseMemoColumn, StationWiseSummaryColumn, summaryColumnsStyles } from './constant'



const StationWiseMemoView = ({ tableDataForMemoFirst, tableDataForMemoSecond, tableDataForMemoThird, HeaderData }) => {
  const { loginData } = useSelector(state => state?.common)
  const [searchResult, setSearchResult] = useState(true)
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const [showTableData, setShowTableData] = useState([])
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load, } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const [tableOneDataForSummary, setTableOneDataForSummary] = useState([
    { Section: 'Section A Total (+)', TotalAmount: 0 },
    { Section: 'Section B Total (+)', TotalAmount: 0 },
    { Section: 'Section C Total (-)', TotalAmount: 0 },
    { Section: 'Section B Hamali (-)', TotalAmount: 0 },
    { Section: 'Section B Fright Comm (-)', TotalAmount: 0 },
    { Section: 'Section B TDS On Comm (+)', TotalAmount: 0 },
    { Section: 'Section B GST On Comm (+)', TotalAmount: 0 },
    { isTotal: true, Section: 'Net Amount', TotalAmount: 0 },
  ])
  useEffect(() => {
    let newData = [...tableOneDataForSummary]

    let allTotal =
      Number(tableDataForMemoFirst[0]?.Total) +
      Number(tableDataForMemoSecond[0]?.Total) -
      Number(tableDataForMemoThird[0]?.Total) -
      Number(tableDataForMemoSecond[0]?.Hamali) -
      Number(tableDataForMemoSecond[0]?.FreightCommission) +
      Number(tableDataForMemoSecond[0]?.TDSOnComm) +
      Number(tableDataForMemoSecond[0]?.GSTOnCommget)

    newData[0]['TotalAmount'] = parseFloat(Number(tableDataForMemoFirst[0]?.Total).toFixed(2))
    newData[1]['TotalAmount'] = parseFloat(Number(tableDataForMemoSecond[0]?.Total).toFixed(2))
    newData[2]['TotalAmount'] = parseFloat(Number(tableDataForMemoThird[0]?.Total).toFixed(2))
    newData[3]['TotalAmount'] = parseFloat(Number(tableDataForMemoSecond[0]?.Hamali).toFixed(2))
    newData[4]['TotalAmount'] = parseFloat(Number(tableDataForMemoSecond[0]?.FreightCommission).toFixed(2))
    newData[5]['TotalAmount'] = parseFloat(Number(tableDataForMemoSecond[0]?.TDSOnComm).toFixed(2))
    newData[6]['TotalAmount'] = parseFloat(Number(tableDataForMemoSecond[0]?.GSTOnCommget).toFixed(2))
    newData[7]['TotalAmount'] = parseFloat(allTotal.toFixed(2))

    setTableOneDataForSummary(newData)
  }, [tableDataForMemoFirst, tableDataForMemoSecond, tableDataForMemoThird])



  // const HeaderData = {
  //   FromDate: 'Dispatch From Date',
  //   ToDate: 'Dispatch To Date',
  //   FromCity: 'Dispatch From City',
  //   FromBranch: 'Dispatch From Branch',
  //   DispatchView: 'Dispatch View',
  //   ToStation: 'To Station',
  //   ToBranch: 'To Branch',
  //   PaymentType: 'Payment Type',
  //   ReportView: 'Report View',
  // }
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const HeaderColumns = excelHeader.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfDetailColumns = StationWiseMemoCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfSummaryColumns = StationWiseMemoColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Dispatch Register Report.pdf`,
      subject: 'Dispatch Register Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [HeaderData],
      columnStyles: {
        0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        6: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        7: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        8: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(`Booking Date : ${HeaderData?.fromDate}  To  ${HeaderData.toDate}`, data.settings.margin.left, 150)
        // doc.text(`Report: ${HeaderData.reportOptions}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfDetailColumns,
      body: tableDataForMemoFirst,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      theme: 'grid',
      columnStyles: detailedColumnsMemoStyles,
      didParseCell: (data) => {
        // DetailsDrawCell(data)
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
          } else {
            data.cell.styles.halign = "left";
          }
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Dispatch Register Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    // doc.setTextColor(0, 0, 0);
    // doc.setFontSize(18).setFont('Roboto', 'bold');
    // doc.text(`Booking Date`, 30, 150);
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfDetailColumns,
      body: tableDataForMemoSecond,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      theme: 'grid',
      columnStyles: detailedColumnsMemoStyles,
      didParseCell: (data) => {
        // DetailsDrawCell(data)
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
          } else {
            data.cell.styles.halign = "left";
          }
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Dispatch Register Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    // doc.setTextColor(0, 0, 0);
    // doc.setFontSize(18).setFont('Roboto', 'bold');
    // doc.text(`Booking Date2`, 30, 150);
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfDetailColumns,
      body: tableDataForMemoThird,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      theme: 'grid',
      columnStyles: detailedColumnsMemoStyles,
      didParseCell: (data) => {
        // DetailsDrawCell(data)
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
          } else {
            data.cell.styles.halign = "left";
          }
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Dispatch Register Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    // doc.setTextColor(0, 0, 0);
    // doc.setFontSize(18).setFont('Roboto', 'bold');
    // doc.text(`Booking Date3`, 30, 150);
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfSummaryColumns,
      body: tableOneDataForSummary,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      theme: 'grid',
      columnStyles: summaryColumnsStyles,
      didParseCell: (data) => {
        // DetailsDrawCell(data)
      },
      willDrawCell: (data) => {
        if (data.row.raw.isTotal) {
          doc.setFillColor(238, 238, 238);
          doc.setFontSize(16)
          doc.setTextColor(0, 0, 0);
          data.cell.styles.valign = 'middle';
        }

      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Dispatch Register Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Dispatch Register Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Dispatch Register Report.pdf')
        focusElemnt("backBtn")
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Dispatch Register Report.pdf')
        focusElemnt("backBtn")
      }, 2000)

    }
  }

  const InsideRowContentFirst = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", textAlign: "left", verticalAlign: "top", maxWidth: "10px" }}>{item.Qty}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.Freight}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.F_S_Tax}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.Cartage}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.C_S_Tax}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.Hamali}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.OptHamali}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", verticalAlign: "top" }}>{item.Total}</TableCell>
      </TableRow>
    )
  }
  const InsideRowContentSecond = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", textAlign: "left", verticalAlign: "top", maxWidth: "10px" }}>{item.Qty}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.Freight}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.F_S_Tax}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.Cartage}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.C_S_Tax}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.Hamali}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.OptHamali}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", verticalAlign: "top" }}>{item.Total}</TableCell>
      </TableRow>
    )
  }
  const InsideRowContentThird = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", textAlign: "left", verticalAlign: "top", maxWidth: "10px" }}>{item.Qty}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.Freight}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "100px" }}>{item.F_S_Tax}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.Cartage}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ padding: "8px 9px", verticalAlign: "top", textAlign: "right", maxWidth: "80px" }}>{item.C_S_Tax}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.Hamali}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.OptHamali}</TableCell>
        <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", verticalAlign: "top" }}>{item.Total}</TableCell>
      </TableRow>
    )
  }
  const InsideRowContentForSummary = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {
          item?.isTotal ?
            <>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.Section}</TableCell>
              <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor, height: "36px" }}>{item.TotalAmount}</TableCell>

            </>
            :
            <>
              <TableCell className="userwiseTD" colSpan={1} style={{ verticalAlign: "top", textAlign: "right", }}>{item.Section}</TableCell>
              <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", verticalAlign: "top" }}>{item.TotalAmount}</TableCell>
            </>
        }
      </TableRow>
    )
  }

  return (
    <>
      <Stack style={{ margin: "0px 10px", marginRight: "0px" }}>
        <Item className='userReport'>
          <Item className='userReport-heading'>
            Report For: Dispatch Register Report
          </Item>
          <Item className='userReport-buttons'>
            {searchResult ? <>
              <Box onKeyDown={(e) => navigation3(e, "ExportToPdf", id.reportmainButton, () => { })}>
                <ReactHtmlTableToExcel
                  id="ExportToExl"
                  className="userWisereporttemExcelBtn"
                  table="tables"
                  filename={`Dispatch Register Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Box>
              <Box>
                <Button variant="outlined" className="userWisereporttembtn" id="ExportToPdf"
                  onClick={() => {
                    setSearchResult(false);
                    printClick(true)
                  }}
                // onKeyDown={(e) => navigation3(e, "PrintBtn", "ExportToExl", () => { setSearchResult(false); printClick(true) })}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined" id="PrintBtn"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setSearchResult(false);
                    printClick(false)
                  }}
                // onKeyDown={(e) => navigation3(e, id.fromDate, "ExportToPdf", () => { setSearchResult(true); printClick(false) })}
                >
                  Print
                </Button>
              </Box>
            </> : <>
              <Box>
                <Button
                  variant="outlined" id="backBtn"
                  className="userWisereporttembtn"
                  onClick={() => { setSearchResult(true) }}
                // onKeyDown={(e) => navigation3(e, id.fromDate, id.reportmainButton, () => { setSearchResult(true); setLargePDF(false); focusElemnt(id.reportmainButton) })}
                >
                  Back
                </Button>
              </Box>
            </>}

          </Item>
        </Item>
      </Stack>
      {
        searchResult ?
          <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
            <TableContainer className="lr-popup-table lrModel " component={Paper} style={{ borderRadius: "6px", border: '1px solid #aeaeae' }}>
              <Table id="tables">
                <Table size="small" aria-label="a dense table" style={{ marginBottom: '10px' }}>
                  <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={6}>
                        <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Register Reports</h3>
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={5}>
                        <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName} </h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={11}></TableCell>
                    </TableRow>
                    <TableRow style={{ color: 'white' }}>
                      {excelHeader?.map((item, i) =>
                        <TableCell
                          className="ReportItemHead"
                          style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                          colSpan={item.colspan}
                          key={i}
                        >
                          {item.headerName}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {moment(headerData.fromDate).format('DD-MMM-YYYY')} */}
                        {HeaderData.FromDate}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {moment(headerData.toDate).format('DD-MMM-YYYY')} */}
                        {HeaderData.ToDate}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData.selSelectedCity} */}
                        {HeaderData.FromCity}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={2}
                      >
                        {/* {headerData?.selSelectedBranch} */}
                        {HeaderData.FromBranch}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.paymentType} */}
                        {HeaderData.DispatchView}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={2}
                      >
                        {/* {headerData?.reportView} */}
                        {HeaderData.ToStation}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.reportOptions} */}
                        {HeaderData.ToBranch}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.reportOptions} */}
                        {HeaderData.PaymentType}
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '600', textAlign: "left" }}
                        colSpan={1}
                      >
                        {/* {headerData?.reportOptions} */}
                        {HeaderData.ReportView}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={11}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: '12px' }}>
                        Amount : To Pay
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: "10px 10px 10px 10px" }}>
                    <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                      {StationWiseMemoCol?.map((item, i) =>
                        <TableCell className="userWiseReportHeading" key={i} style={{ ...item.xlCol, textAlign: item.align, verticalAlign: "top", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor.isHeadingColor, whiteSpace: "pre-line" }}>{item?.headerName}</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  {tableDataForMemoFirst?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={14}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableDataForMemoFirst.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                      {tableDataForMemoFirst?.map((item, index) => (
                        <InsideRowContentFirst item={item} index={index} key={index} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
                <Table size="small" aria-label="a dense table" style={{ marginBottom: '10px' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: '12px' }}>
                        Amount : ALL
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: "10px 10px 10px 10px" }}>
                    <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                      {StationWiseMemoCol?.map((item, i) =>
                        <TableCell className="userWiseReportHeading" key={i} style={{ ...item.xlCol, textAlign: item.align, verticalAlign: "top", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor.isHeadingColor, whiteSpace: "pre-line" }}>{item?.headerName}</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  {tableDataForMemoSecond?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={14}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableDataForMemoSecond.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                      {tableDataForMemoSecond?.map((item, index) => (
                        <InsideRowContentSecond item={item} index={index} key={index} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
                <Table size="small" aria-label="a dense table" style={{ marginBottom: '10px' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: '12px' }}>
                        Amount : To Pay
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: "10px 10px 10px 10px" }}>
                    <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                      {StationWiseMemoCol?.map((item, i) =>
                        <TableCell className="userWiseReportHeading" key={i} style={{ ...item.xlCol, textAlign: item.align, verticalAlign: "top", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor.isHeadingColor, whiteSpace: "pre-line" }}>{item?.headerName}</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  {tableDataForMemoThird?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={14}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableDataForMemoThird.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                      {tableDataForMemoThird?.map((item, index) => (
                        <InsideRowContentThird item={item} index={index} key={index} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: '12px', textAlign: 'right' }}>
                        Summary
                      </TableCell>
                      <TableCell style={{ fontSize: '12px' }}>

                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {/* <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: "10px 10px 10px 10px" }}>
                    <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                      {StationWiseSummaryColumn?.map((item, i) =>
                        <TableCell className="userWiseReportHeading" key={i} style={{ textAlign: item.align, verticalAlign: "top", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor.isHeadingColor, whiteSpace: "pre-line" }}>{item?.headerName}</TableCell>
                      )}
                    </TableRow>
                  </TableHead> */}
                  {tableOneDataForSummary?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={14}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableOneDataForSummary.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                      {tableOneDataForSummary?.map((item, index) => (
                        <InsideRowContentForSummary item={item} index={index} key={index} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
              </Table>
            </TableContainer>

          </Stack>
          :
          <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
              {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
              {load ? (
                <object
                  id="gbDetailsOutput"
                  type="application/pdf"
                  width={"100%"}
                  height="440"
                  title="MTLPL -Cargo System -Good Balance Report"
                  aria-label="MTLPL -Cargo System -Good Balance Report"
                ></object>
              ) : (
                ''
              )}
              {/* </>
                        } */}
            </Box>
          </>

      }

    </>
  )
}

export default StationWiseMemoView

